import { render, staticRenderFns } from "./v-internet-explorer.vue?vue&type=template&id=862a9886&"
import script from "./v-internet-explorer.vue?vue&type=script&lang=js&"
export * from "./v-internet-explorer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports